export const iconsCategoriesSelector = (state) => {
  return state.icons.categories;
};

export const iconsStylesSelector = (state) => {
  return state.icons.styles;
};
